import request from '@api/request';

export const postApi = async (id) =>
  await request({
    url: `/posts/${id}`,
    type: 'get',
  });
